import { render, staticRenderFns } from "./SectionMicro.vue?vue&type=template&id=4d395629&scoped=true&"
import script from "./SectionMicro.vue?vue&type=script&lang=js&"
export * from "./SectionMicro.vue?vue&type=script&lang=js&"
import style0 from "./SectionMicro.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionMicro.vue?vue&type=style&index=1&id=4d395629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d395629",
  null
  
)

export default component.exports